import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IJobFunction } from "../../utils/types/models";

export default createEntityReducer<IJobFunction>(Endpoint.JobFunctions, Endpoint.JobFunctionsList);
